import { defineStore } from 'pinia'

/**
 * Tema claro/escuro (DESIGN.md, seção 2).
 * - Primeira visita: segue a preferência do celular/computador (prefers-color-scheme).
 * - Depois que a pessoa escolhe no botão, a escolha fica salva e passa a valer.
 * - index.html aplica o tema antes do Vue carregar (sem "piscar" o tema errado).
 */
const STORAGE_KEY = 'theme'
const THEME_COLOR = { dark: '#121318', light: '#f4f4f6' }

function readSaved() {
  try {
    const value = localStorage.getItem(STORAGE_KEY)
    return value === 'dark' || value === 'light' ? value : null
  } catch (err) {
    return null
  }
}

function systemPrefersDark() {
  return typeof window !== 'undefined' && !!window.matchMedia?.('(prefers-color-scheme: dark)').matches
}

export const useThemeStore = defineStore('theme', {
  state: () => {
    const saved = readSaved()
    return { isDark: saved ? saved === 'dark' : systemPrefersDark() }
  },
  actions: {
    toggleTheme() {
      this.isDark = !this.isDark
      try { localStorage.setItem(STORAGE_KEY, this.isDark ? 'dark' : 'light') } catch (err) {}
      this.applyTheme()
    },
    applyTheme() {
      const theme = this.isDark ? 'dark' : 'light'
      for (const el of [document.documentElement, document.body]) {
        if (!el) continue
        el.classList.toggle('dark', this.isDark)
        el.setAttribute('data-bs-theme', theme)
      }
      document.documentElement.style.backgroundColor = THEME_COLOR[theme] // mesma cor que o index.html aplica antes do Vue
      document.querySelector('meta[name="theme-color"]')?.setAttribute('content', THEME_COLOR[theme])
    },
    initTheme() {
      this.applyTheme()
      // Sem escolha salva, acompanha quando o sistema muda de claro para escuro (ex.: à noite)
      window.matchMedia?.('(prefers-color-scheme: dark)').addEventListener?.('change', (event) => {
        if (readSaved()) return
        this.isDark = event.matches
        this.applyTheme()
      })
    }
  }
})
